export const getEmbeddedInfo = (isEmbedded?: boolean): string => {
    if (isEmbedded === undefined) return "";
    if (isEmbedded) return "(Embedded)";
    else return "";
};
